import axios from 'axios';
import store from '@/store'
// 创建axios实例
const service = axios.create({
    // API的base_url
    baseURL: store.state.IPAss.TP,
    // 请求超时时间
    timeout: 12000000
});

// 处理文件流下载
export function downloadFileByPost(url,) {
    var temp = url.split("/")
    temp = temp[temp.length - 1]
    const Newurl = `/work/file/download?fileUrl=${encodeURI(url)}`
    return service.get(Newurl, {
        responseType: 'blob', // 重要：设置响应类型为blob
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': window.sessionStorage.getItem('userIdStr'),
            'useridstr': window.sessionStorage.getItem('userIdStr'),
            // 'Priority-value': 'wbj'
        },
        onDownloadProgress(progress) {  
            // downProgress = Math.round((100 * progress.loaded) / progress.total); // progress对象中的loaded表示已经下载的数量，total表示总数量，这里计算出百分比。注意这里一定需要后端接口返回 Content-Length，没有的话是拿不到的
            store.commit("SET_PROGRESS", {
                progress: progress.loaded ,
            }); // 将此次下载的文件名和下载进度组成对象再用vuex状态管理
        },
    }).then(res => {
        const link = document.createElement("a");
        // 创建Blob对象, 固定写法
        let blob = new Blob([res.data], { type: "application/x-download" });
        console.log(blob.size)
        // 设置元素样式不可⻅
        link.style.display = "none";
        // 创建下载链接
        link.href = URL.createObjectURL(blob);
        // 获取⽂件名(后端应确保正确返回⽂件名)
        link.setAttribute("download", decodeURI(temp));
        // 加⼊dom树
        document.body.appendChild(link);
        // ⼿动触发点击事件
        link.click();
        // 移除之前创建的元素
        document.body.removeChild(link);
        // 释放Blob对象
        window.URL.revokeObjectURL(link.href);
        return blob
    })
}

export default service;